import { DEFAULT_PROPERTYCLASS_KEY } from "../core/prop/Property";
import { LengthProperty, NumberProperty, PropertyClass, PropertyValue, StringProperty } from "../core/prop/Property";
import { wcfConfig } from "../utils";
import * as basket from "../eaiws/basket";
const TRIM_TEXT_REGEX = new RegExp("[ :]+$"); //space and colon at the end of the string
export class ArticlePropertyHelpers {
    static GetProperties(pItemId, pSession, pProvider, pArticleData, pSetValueCallback) {
        let tProperties = null;
        if (pArticleData != null && pArticleData.properties != null) {
            tProperties = [];
            for (const tEaiProperty of pArticleData.properties) {
                const tProperty = ArticlePropertyHelpers.CreateProperty(pItemId, pSession, pProvider, tEaiProperty, pArticleData, pSetValueCallback);
                if (tProperty != null)
                    tProperties.push(tProperty);
            }
        }
        return (tProperties);
    }
    static GetPropertyClasses(pArticleData) {
        let tClasses = null;
        if (pArticleData != null && pArticleData.propertyClasses != null) {
            tClasses = [];
            for (const tEaiClass of pArticleData.propertyClasses) {
                if (tEaiClass.name != "OI_NONE_PROPCLASS") {
                    tClasses.push(new PropertyClass(this.GetClassKey(tEaiClass.name, pArticleData), tEaiClass.description));
                }
                else {
                    //create default class as a placeholder to ensure correct order of classes
                    tClasses.push(new PropertyClass(DEFAULT_PROPERTYCLASS_KEY));
                }
            }
        }
        return (tClasses);
    }
    static GetPropertyUserData(pProperty) {
        if (pProperty == null || pProperty.userData == null)
            return (null);
        const tUserData = pProperty.userData;
        if (tUserData.eaiwsProperty == null || tUserData.eaiwsArticleData == null)
            return (null);
        return (tUserData);
    }
    //// private ///////////////////////////////////////////////////////////////////////////////
    static GetClassKey(pClassName, pArticleData) {
        return (pArticleData.manufacturerId + "_" + pClassName);
    }
    static CreateProperty(pItemId, pSession, pProvider, pEaiProperty, pArticleData, pSetValueCallback) {
        if (pEaiProperty == null || pArticleData == null)
            return (null);
        const tConfOptions = wcfConfig.articleConfigurationOptions;
        const tUserData = {
            eaiwsProperty: pEaiProperty,
            eaiwsArticleData: pArticleData
        };
        const tPropKey = "[" + pEaiProperty.type + "]" + pArticleData.manufacturerId + "_" +
            pEaiProperty.propName;
        const tPropText = tConfOptions.trimPropText ? pEaiProperty.propText.replace(TRIM_TEXT_REGEX, "") : pEaiProperty.propText;
        let tProperty;
        if (pEaiProperty.type === "Numeric" || pEaiProperty.type === "Length") {
            const tNumProp = pEaiProperty.type === "Length" ?
                new LengthProperty(pProvider, tPropKey, tPropText) :
                new NumberProperty(pProvider, tPropKey, tPropText);
            if (pEaiProperty.digits != null)
                tNumProp.numDigits = pEaiProperty.digits;
            if (pEaiProperty.decDigits != null)
                tNumProp.numDecDigits = pEaiProperty.decDigits;
            //min-maxValue
            if (pEaiProperty.intervals != null && pEaiProperty.intervals.length > 0) {
                tNumProp.minValue = pEaiProperty.intervals[0].minValue;
                tNumProp.maxValue = pEaiProperty.intervals[0].maxValue;
                for (let i = 1; i < pEaiProperty.intervals.length; ++i) {
                    if (pEaiProperty.intervals[i].minValue < tNumProp.minValue)
                        tNumProp.minValue = pEaiProperty.intervals[i].minValue;
                    if (pEaiProperty.intervals[i].maxValue > tNumProp.maxValue)
                        tNumProp.maxValue = pEaiProperty.intervals[i].maxValue;
                }
            }
            tProperty = tNumProp;
        }
        else {
            const tStringProp = new StringProperty(pProvider, tPropKey, tPropText);
            if (pEaiProperty.width != null)
                tStringProp.maxLength = pEaiProperty.width;
            if (pEaiProperty.multiLine != null)
                tStringProp.multiLine = pEaiProperty.multiLine;
            tProperty = tStringProp;
        }
        if (pEaiProperty.propClass != "OI_NONE_PROPCLASS")
            tProperty.class = this.GetClassKey(pEaiProperty.propClass, pArticleData);
        tProperty.visible = pEaiProperty.visible;
        tProperty.editable = pEaiProperty.editable;
        tProperty.choiceList = pEaiProperty.choiceList;
        tProperty.allowCustomChoice = pEaiProperty.addValues;
        tProperty.undoable = false;
        tProperty.userData = tUserData;
        tProperty.getValue = () => {
            return (ArticlePropertyHelpers.CreatePropertyValue(pEaiProperty.value));
        };
        tProperty.setValue = (pValue) => {
            return (pSetValueCallback(pEaiProperty, pValue));
        };
        if (tProperty.choiceList) {
            tProperty.getChoices = () => {
                return (ArticlePropertyHelpers.GetPropertyChoices(pItemId, pSession, pEaiProperty));
            };
        }
        return (tProperty);
    }
    static CreatePropertyValue(pEaiValue) {
        var _a, _b;
        const tValue = new PropertyValue(pEaiValue.value, pEaiValue.text);
        tValue.smallIcon = pEaiValue.smallIcon;
        tValue.largeIcon = pEaiValue.largeIcon;
        tValue.image = (_a = pEaiValue.image) !== null && _a !== void 0 ? _a : null;
        tValue.selectable = (_b = pEaiValue.selectable) !== null && _b !== void 0 ? _b : true;
        if (pEaiValue.surcharge != null && pEaiValue.surcharge.value != null) {
            tValue.surcharge = {
                value: pEaiValue.surcharge.value,
                currency: pEaiValue.surcharge.currency
            };
        }
        return (tValue);
    }
    static GetPropertyChoices(pItemId, pSession, pEaiProperty) {
        if (pEaiProperty == null || !pEaiProperty.choiceList)
            return (Promise.resolve(null));
        const tConfOptions = wcfConfig.articleConfigurationOptions;
        const tOptions = new basket.GetChoiceListOptions();
        tOptions.formatSurcharge = false;
        tOptions.highResPropValueIcons = true;
        tOptions.fetchPropValueImages = tConfOptions.fetchPropValueImages;
        const tPromise = pSession.basket.getChoiceList(pItemId, pEaiProperty.propClass, pEaiProperty.propName, tOptions).then((pChoices) => {
            const tChoices = new Array();
            for (const tEaiChoice of pChoices)
                tChoices.push(ArticlePropertyHelpers.CreatePropertyValue(tEaiChoice));
            return (tChoices);
        });
        return (tPromise);
    }
}
